import * as amplitude from '@amplitude/analytics-browser';

if (process.env.REACT_APP_AMPLITUDE_KEY) {
  amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY);
}

export const amplitudeTrack = (eventInput: string | amplitude.Types.BaseEvent, eventProperties?: Record<string, any> | undefined, eventOptions?: amplitude.Types.EventOptions | undefined) => {
  try {
    amplitude.track(eventInput, eventProperties, eventOptions);    
  } catch (error) {
    console.error('Amplitude error:', error);
  }
} 
